import r from "../managers/braze-instance.js";
import Y from "./content-cards-provider.js";
const Z = {
  l: !1,
  provider: null,
  m: () => (
    Z.p(),
    Z.provider ||
      ((Z.provider = new Y(r.ir(), r.j(), r.v(), r.tr(), r.g())),
      r._(Z.provider)),
    Z.provider
  ),
  p: () => {
    Z.l || (r.h(Z), (Z.l = !0));
  },
  destroy: () => {
    (Z.provider = null), (Z.l = !1);
  },
};
export default Z;
